import * as React from 'react'
import {useEffect, useState} from 'react'
import {Hub} from 'yougile-model'
import {Task} from '@extensions/task'
import {TaskDescriptionHistoryWrapper} from './task-description-history'
import {TaskDescriptionLayout} from './task-description-layout'
import {
  TaskDescriptionContext,
  TaskDescriptionStore
} from './task-description-store'

type Props = {
  hub?: Hub
  headerHeight: number
  newBg?: boolean
}

export const TaskDescription = ({hub, headerHeight, newBg}: Props) => {
  const [store] = useState(() => new TaskDescriptionStore(hub))

  useEffect(() => store.dispose, [store])

  return (
    <TaskDescriptionContext.Provider value={store}>
      <TaskDescriptionLayout
        hub={hub}
        headerHeight={headerHeight}
        newBg={newBg}
      />
      {!Task.isTaskTemplate(hub) && <TaskDescriptionHistoryWrapper />}
    </TaskDescriptionContext.Provider>
  )
}
